import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMeQuery, useMembersQuery } from '@platform/state/api';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { MemberRow } from './MemberRow';
import { useMemberActions } from './useMemberActions';
import { useMembersSummary } from './useMembersSummary';
import './members.css';

/**
 * «Учасники» робочого простору (прототип v4 G:L2725–2760, Головна › Учасники; Адміністрування › Люди › Учасники): заголовок, «Простір ·
 * N учасників · M очікують», «Учасники · N» і картка рядків у порядку API (ви першими, далі в порядку членства — GET /members) зі зміною ролі й вилученням.
 * ?focus=<userId> (посилання «Автор» картки запису) виділяє рядок цієї людини, як mbFocus прототипу.
 */
export function MembersPage() {
  const { t } = useTranslation();
  const { ws } = useWorkspaceParams();
  const [params] = useSearchParams();
  const focus = params.get('focus');
  const { data: me } = useMeQuery();
  const { data: members } = useMembersQuery(ws, { skip: !ws });
  const summary = useMembersSummary(ws);
  const actions = useMemberActions(ws);
  return (
    <div className="mb-page">
      <div className="mb-head"><h1>{t('membersPage.members')}</h1><span className="muted">{summary}</span></div>
      <div className="mb-section">
        <div className="mb-label">{t('membersPage.listTitle', { count: members?.length ?? 0 })}</div>
        <div className="mb-list">
          {(members ?? []).map((m) => <MemberRow key={m.user.id} member={m} you={m.user.id === me?.id} reason={actions.reasonOf(m)} focused={m.user.id === focus}
            onRole={(role) => actions.changeRole(m, role)} onRemove={() => actions.remove(m)} />)}
          {members && !members.length && <div className="mb-empty">{t('membersPage.noMembers')}</div>}
        </div>
      </div>
      {actions.dialog}
    </div>
  );
}
